import { http } from './http';
import { apiHelper } from 'shared';

const controllerName = 'reader-requests';

class ReaderRequests {
  get(paging, sorting, filters) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ ...paging, ...sorting, ...filters });

    return http.get(`/${controllerName}/${queryString}`);
  }

  getById(id) {
    return http.get(`/${controllerName}/${id}`);
  }

  create(readerRequest) {
    return http.post(`/${controllerName}`, readerRequest);
  }

  process(readerRequestId) {
    return http.put(`/${controllerName}/${readerRequestId}/response`, {});
  }

  async export(filters) {
    const headersT = await http.getBearerToken();
    const options = {
      headers: headersT.headers,
      method: 'GET',
      responseType: 'blob'
    };

    const queryString = apiHelper.composeQueryString({ ...filters });
    const response = await http.get(`/${controllerName}/export/${queryString}`, options);
    return response.data;
  }
}

export const readerRequests = new ReaderRequests();
